/* eslint-disable */
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import queryString from 'query-string';
import i18n from "locales/i18n";

import { Box, Button, CircularProgress, FormControl } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import PageInfo from 'components/PageInfo';
// import { getWorkingPartsByQuery } from 'components/axios/workingPartAxios';
// import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import { getAttentionObservationsByQueryString } from 'components/axios/equipmentAlertsAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import { BootstrapInput } from 'data/data';
import { useEnumApi } from 'contexts/EnumApiContext';
import CommonExcelDownload from "components/CommonExcelDownload";
import { useTranslation } from 'react-i18next';

const ObserveMaintenance = () => {
  const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();
  const { t } = useTranslation();
  // const observeStatuss = getEnumValueByEnumName('AttentionObservationStatus');
  // const observeStatuss = [
  //   {code : "ongoing", title : t('message.common.text.available')},
  //   {code : "released", title : t('message.common.text.release')}
  // ];
  const navigate = useNavigate();
  const [searchField, setSearchField] = useState('name');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  const [attentionObservations, setAttentionObservations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isParam, setIsParam] = useState(false);
  // const [toggleStr, setToggleStr] = useState(true);

  //const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
  //const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
  const [observeStatus, setObserveStatus] = useState('');
  const [alertType, setAlertType] = useState('');
  // const [subwayCode, setSubwayCode] = useState('');
  // const [workingPartId, setWorkingPartId] = useState('');
  // const [stationId, setStationId] = useState('');
  const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
  const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
  const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
 
  const [workingParts, setWorkingParts] = useState([]);
  const [stations, setStations] = useState([]);
  //let [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState([]);
  const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);

  const [sortModel, setSortModel] = useState(null);
  const excelTitle = t('menu.cmms.equipment-observe');
  const excelTopHeaders = ["No.", t('message.common.subtitle.status'), t('message.common.subtitle.observe.period'), t('message.common.subtitle.observe.regUser'), 
    t('message.common.subtitle.alertedAt'), t('message.common.subtitle.alertType'), t('message.common.subtitle.alertCategory'),
    // t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station.name'),
    t('message.common.subtitle.equipment.level2'), t('message.common.subtitle.equipment.name'), t('message.common.subtitle.equipment.number')];
  const fileName = excelTitle+"_"+Date.now();
  const [excelDatas, setExcelDatas] = useState([]);

  const today = new Date();
  //const connectProblemDay = dayjs(today).subtract(7, "d").format("YYYY-MM-DD");
  const todayStr = dayjs(today).format("YYYY-MM-DD");
  const todayNum = dayjs(today).format("YYYYMMDD");

  const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);

  let qs = queryString.parse(window.location.search);
  
  let falutStatusSelectColor = "";
  let statusColor = "";
  //let diffDate = 0;
  // const searchParam = '?searchField='+searchField+'&searchKeyword='+searchKeyword+'&page='+currentPage+'&size='+pageSize
  // +"&searchStatus="+observeStatus+"&searchType="+alertType+"&searchSubway="+subwayCode+"&searchWorkingPart="+workingPartId
  // +"&searchStation="+stationId+"&searchlevel1="+equipmentCategoryLevel1Id+"&searchlevel2="+equipmentCategoryLevel2Id+"&searchlevel3="+equipmentCategoryLevel3Id;
  const [searchParam, setSearchParam] = useState({});
  const [searchParamString, setSearchParamString] = useState('');

  if (observeStatus === '' || observeStatus === "sum") {
    falutStatusSelectColor = " selected";
  }
  
  const columns = [
    { field: 'no', headerName: 'No.', sortable: false, width: 80
      , valueGetter:(params) => params.row?.no
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.no}</Link>)
    },
    { field: 'status', headerName: t('message.common.subtitle.status'), sortable: true, width: 80,
      cellClassName : 'statusButton'
      , renderCell:(params)=>
        (<div style={{textAlign:"center"}} className={params.row?.status === 'V' ? 'condition1' : 'condition4'}>
            {getEnumValueByEnumNameAndCode("AttentionObservationStatus", params.row?.status)?.[0]?.title}
        </div>)
    },
    { field: 'endYmd', headerName: t('message.common.subtitle.observe.period'), sortable:true, width: 150
      , valueGetter:(params)=>params.row?.endYmd
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.endYmd}</Link>)
    },
    { field: 'regUser', headerName: t('message.common.subtitle.observe.regUser'), sortable:true, width: 150
      , valueGetter:(params)=>params.row?.regUser
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.regUser}</Link>)
    },
    { field: 'equipmentAlert.latestAlertedAt', headerName: t('message.common.subtitle.alertedAt'), sortable:true, width: 150
      , valueGetter:(params)=>params.row?.equipmentAlert?.latestAlertedAt && dayjs(params.row?.equipmentAlert?.latestAlertedAt).format("YYYY-MM-DD HH:mm")
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.equipmentAlert?.latestAlertedAt && dayjs(params.row?.equipmentAlert?.latestAlertedAt).format("YYYY-MM-DD HH:mm")}</Link>)
    },
    { field: 'equipmentAlert.alertType', headerName: t('message.common.subtitle.alertType'), sortable:true, width: 100
      , valueGetter:(params)=>getEnumValueByEnumNameAndCode("AlertType", params.row?.equipmentAlert?.alertType)?.[0]?.title
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertType", params.row?.equipmentAlert?.alertType)?.[0]?.title}</Link>)
    },
    { field: 'equipmentAlert.alertCategory', headerName: t('message.common.subtitle.alertCategory'), sortable:true, width: 100
      , valueGetter:(params)=>getEnumValueByEnumNameAndCode("AlertCategory", params.row?.equipmentAlert?.alertCategory)?.[0]?.title 
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertCategory", params.row?.equipmentAlert?.alertCategory)?.[0]?.title}</Link>)
    },
    // { field: 'equipment.station.workingPart.subwayLine', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 100
    //   , valueGetter:(params)=>getEnumValueByEnumNameAndCode("SubwayLine", params.row?.equipment?.station?.workingPart?.subwayLine)?.[0]?.title 
    //   // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("SubwayLine", params.row?.equipment?.station?.workingPart?.subwayLine)?.[0]?.title}</Link>)
    // },
    // { field: 'equipment.station.workingPart.name', headerName: t('message.common.subtitle.workingPart'), sortable:true, width: 120
    //   , valueGetter:(params)=>params.row?.equipment?.station?.workingPart?.name
    //   // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.station?.workingPart?.name}</Link>)
    // },
    // { field: 'equipment.station.name', headerName: t('message.common.subtitle.station.name'), sortable:true, width: 120
    //   , valueGetter:(params)=>params.row?.equipment?.station?.name 
    //   // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.station?.name}</Link>)
    // },
    { field: 'equipment.equipmentCtgr.parent.name', headerName: t('message.common.subtitle.equipment.level2'), sortable:true, width: 120
      , valueGetter:(params)=>params.row?.equipment?.equipmentCtgr?.parent?.name
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.name}</Link>)
    },
    { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
      , valueGetter:(params)=>params.row?.equipment?.name 
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
    },
    { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
      , valueGetter:(params)=>params.row?.equipment?.equipmentNo 
      // , renderCell:(params)=>(<Link to={'/management/maintenance/observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
    }
  ];

  const handlePaging = (value) => {
    //console.log(value);
    value = isNaN(value) ? 1 : value;
    setCurrentPage(value-1);
    setIsLoading(false);

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = (value-1);
    setSearchParam(searchParamCopy);
  }
  
  useEffect(()=>{
    const searchOrders = searchParam.searchOrder;
    const searchParamCopy = {...searchParam};
    // console.log(searchParam)
    // console.log(searchParamCopy)
    delete searchParamCopy.searchOrder;
    let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    // console.log(searchString)
    if (searchOrders && searchOrders.length > 0) {
      let sortString = '';
      searchOrders.forEach(order=>sortString+="&sort="+order.sort)
      // let sortModel = [];
      // // searchOrders.map(order=>console.log(order));
      // searchOrders.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
      // // setSortModel(sortModel)
      // console.log(sortString)
      searchString += sortString;
    }
    // console.log("?"+searchString)
    setSearchParamString("?"+searchString)
  }, [searchParam])

  useEffect(()=>{
    const searchParamCopy = {...searchParam};
    // console.log(sortModel)
    let searchOrders = [];
    if (sortModel && sortModel.length > 0) {
      searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
    } else {
      searchOrders.push({sort : "endYmd,asc"});
      searchOrders.push({sort : "equipmentAlert.latestAlertedAt,desc"});
    }
    // delete searchParamCopy.searchOrder;
    // console.log(searchOrders)
    searchParamCopy.searchOrder = searchOrders;
    setSearchParam(searchParamCopy)
  },[sortModel])

  useEffect(()=> {
    if (qs) {
      if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
      if (qs.size) setPageSize(qs.size);
      if (qs.searchField) setSearchField(qs.searchField);
      if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);

      if (qs.searchStatus) setObserveStatus(qs.searchStatus);
      if (qs.searchType) setAlertType(qs.searchType);
      // if (qs.searchSubway) setSubwayCode(qs.searchSubway);
      // if (qs.searchWorkingPart) setWorkingPartId(qs.searchWorkingPart);
      // if (qs.searchStation) setStationId(qs.searchStation);
      if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
      if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
      if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);

      
      let searchParamCopy = {...searchParam};
      if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
      if (qs.size) {searchParamCopy.size = qs.size} ;
      if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
      if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
      if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
      if (qs.searchType) {searchParamCopy.searchType = qs.searchType};
      // if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
      // if (qs.searchWorkingPart) {searchParamCopy.searchWorkingPart = qs.searchWorkingPart};
      // if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
      if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
      if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
      if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
      if (qs.sort && qs.sort.length > 0) {
        // console.log(qs.sort);
        let orders = [];
        let sortModel = [];
        if (!Array.isArray(qs.sort)) {
          orders.push({sort:qs.sort});
          sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
        } else {
          (qs.sort).forEach(order=>orders.push({sort:order}));
          qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
        }
        // console.log(sortModel)
        setSortModel(sortModel)
        searchParamCopy.searchOrder = orders;
      } else {
        delete searchParamCopy.searchOrder
      };
      // console.log(searchParamCopy)
      setSearchParam(searchParamCopy);
    }
    setIsParam(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchStatus, qs.searchType, qs.searchSubway
    , qs.searchWorkingPart, qs.searchStation, qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

  // 호선 선택시 해당 파트 목록 가져오기
  // useEffect(()=>{
  //   //console.log(subwayCode);
  //   if (subwayCode) {
  //     const param = {"subwayLine" : subwayCode, size:50}
  //     getWorkingPartsByQuery(param).then((data)=>{
  //       //console.log(data);
  //       if (data && data._embedded) {
  //         //console.log(data[0].workingParts);
  //         let workingParts = data._embedded.workingParts;
  //         partSort(workingParts);
  //         setWorkingParts(workingParts);
  //       } else {
  //         setWorkingParts([]);
  //       }
  //       setStations([]);
  //     });
  //   }
  // },[subwayCode]);

  // // 파트 선택시 해당 역사 목록 가져오기
  // useEffect(()=>{
  //   //console.log(workingPartId);
  //   if (workingPartId) {
  //     const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
  //     getStationsByQuery(param).then((data)=>{
  //       if (data && data._embedded) {
  //         setStations(data._embedded.stations);
  //       } else {
  //         setStations([]);
  //       }
  //     });
  //   }
  // },[workingPartId]);

  // 설비중분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel1Id) {
      const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel2s(list);
          } else {
            setEquipmentCategoryLevel2s([]);
          }
        } else {
          setEquipmentCategoryLevel2s([]);
        }
        setEquipmentCategoryLevel3s([]);
      });
    }
  },[equipmentCategoryLevel1Id]);

  // 설비분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel2Id) {
      const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel3s(list);
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        } else {
          setEquipmentCategoryLevel3s([]);
        }
      });
    }
  },[equipmentCategoryLevel2Id]);

  // 목록
  useEffect(()=> {
    if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam && getEnumValueByEnumName("SubwayLine")) {
      //console.log('000');
      attentionObservationList();
      // equipmentGroupCountList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isLoading, observeStatus, isParam, getEnumValueByEnumName("SubwayLine"), sortModel]);

  let [groupCounts, setGroupCounts] = useState([]);
  let [totalGroupCount, setTotalGroupCount] = useState(0);

  // const equipmentGroupCountList = async() => {
  //   await getAttentionObservationsCountGroupByStatus().then((res)=>{
  //     //console.log('============================================');
  //     groupCounts = [];
  //     totalGroupCount = 0;
  //     if (res != null) {
  //       let isInclude = false;
  //       let statussData = res.data;

  //       setGroupCounts([{}]);
  //       if (observeStatuss) {
  //         observeStatuss.map(function(item1) {
  //           //console.log(item1);
  //           isInclude = false;
  //           statussData.map(function(item2) {
  //             //console.log(item2);
  //             if (item2.id === item1.code) {
  //               //console.log('item2.code : ' + item2.code);
  //               if (item2.count === undefined)
  //                 item2.count = 0;
  //                 //console.log('item2 : ', item2);
  //               groupCounts.push(...[item2]);
  //               totalGroupCount += item2.count;
  //               isInclude = true;
  //             }
  //           })

  //           if (!isInclude) {
  //             //console.log('============');
  //             let defaultStatus = [{
  //               name : item1.code,
  //               id : item1.code,
  //               title : item1.title,
  //               count : 0,
  //             }];
  //             groupCounts.push(...defaultStatus);
  //           }
  //         })
  //       }
  //       setGroupCounts(groupCounts);
  //       setTotalGroupCount(totalGroupCount);
  //       //console.log(equipmentGroupCounts);
  //     }
  //   });
  // }

  const attentionObservationList = (curPage=currentPage) => {
    //console.log('list');
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

    let param = {
      // sort : "endYmd,desc,equipmentAlert.latestAlertedAt,asc",
      // sort : "endYmd,desc",
      page : curPage,
      size : pageSize
    };
    if (alertType) {
      param["equipmentAlert.alertType"] = alertType;
    }
    // if (subwayCode) {
    //   param['equipment.station.workingPart.subwayLine'] = subwayCode;
    // }
    // if (workingPartId) {
    //   param['equipment.station.workingPart.id'] = workingPartId;
    // }
    // if (stationId) {
    //   param['equipment.station.id'] = stationId;
    // }
    if (equipmentCategoryLevel1Id) {
      param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
    }
    if (equipmentCategoryLevel2Id) {
      param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
    }
    if (equipmentCategoryLevel3Id) {
      param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
    }

    // if (observeStatus === 'sum')
    //   delete param.endYmd;
    //   //param.endYmd = "";
    // else if (observeStatus === 'V')
    //   param.endYmd = "gte("+todayStr+")";
    // else if (observeStatus === 'R')
    //   param.endYmd = "lt("+todayStr+")";
    param.endYmd = "gte("+todayStr+")";

    //let keyword = searchKeyword;
    if (searchKeyword) {
      //if (searchField) {
        // if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
        //   keyword = 'contains('+searchKeyword+')';
        // }

        if (searchField === 'name') {
          param['equipment.name'] = 'contains('+searchKeyword+')';
        } else if (searchField === 'equipmentNo') {
          param['equipment.equipmentNo'] = 'contains('+searchKeyword+')';
        }
      // } else {
      //   keyword = 'contains('+searchKeyword+')';
      //   param.name = keyword;
      //   param.equipmentNo = keyword;
      // }
    }
    //console.log(param);
    // let queryString = Object.entries(param).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
    // queryString += "&sort=endYmd,asc&sort=equipmentAlert.latestAlertedAt,desc";
    let addQueryString = "";
    if (sortModel && sortModel.length > 0)
      addQueryString += "&sort="+sortModel[0].field+","+sortModel[0].sort;
    else
      addQueryString += "&sort=endYmd,asc&sort=equipmentAlert.latestAlertedAt,desc";
    // if (observeStatus === 'V') {
    //   addQueryString += "&endYmd=isNull()";
    // // } else if (observeStatus === 'sum') {
    // //   queryString += "&endYmd=isNull()";
    // //   queryString += "&endYmd=gt("+todayStr+")";
    // //   queryString += "&endYmd=lte("+todayStr+")";
    // }
    addQueryString += "&endYmd=isNull()";

    let queryString = Object.entries(param).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
    queryString += addQueryString;
    // console.log(queryString);
    Promise.all([
      getAttentionObservationsByQueryString("?"+queryString).then((data)=>{
        if (data != null) {
          // console.log(data);
          if(data.page) {
            setPageInfo(data.page);
          } else {
            setCurrentPage(0);
            pageInfo = {
              size : pageInfo.size,
              totalElements : 0,
              totalPages : 0,
              number : 0
            }
            setPageInfo(pageInfo);
          }
          if(data._embedded) {
            let list = data._embedded.attentionObservations;
            list && list.map(function(task, i) {
              task.idx = (i+1);
              task.no = data.page.totalElements-((currentPage)*data.page.size)-i;
            })
            // console.log(list)
            setAttentionObservations(list);
            setIsLoading(true);
            return data.page.totalElements;
            // setAttentionObservations(data._embedded.attentionObservations);
          } else {
            setAttentionObservations([]);
          }
        } else {
          pageInfo = {
            size : pageInfo.size,
            totalElements : 0,
            totalPages : 0,
            number : 0
          }
          setPageInfo(pageInfo);
          setAttentionObservations([]);
        }
        setIsLoading(true);
        return 0;
      })
    ]).then((res)=>{
      // console.log(res);
      const totalCount = res[0];
      if (totalCount) {
        // console.log(totalCount)
        delete param.page;
        param.page = 0;
        delete param.size;
        param.size = totalCount;
        queryString = Object.entries(param).map(([key, value]) => (value && key + '=' + value)).filter(v => v).join('&');
        queryString += addQueryString;
        // console.log(queryString)
        getAttentionObservationsByQueryString("?"+queryString).then((data)=>{
          if (data != null) {
          //  console.log(data);
            if(data._embedded) {
              let list = data._embedded.attentionObservations;
              let excelDatas = [];
              let excelData = [];
              list && list.forEach(function (column, a) {
                excelData = [
                    (data.page.totalElements-a),
                    ((getEnumValueByEnumNameAndCode("AttentionObservationStatus", column?.status)?.[0]?.title) || ''),
                    ((column.endYmd) || ''),
                    ((column.regUser) || ''),
                    ((column.equipmentAlert?.latestAlertedAt && dayjs(column.equipmentAlert?.latestAlertedAt).format("YYYY-MM-DD HH:mm")) || ''),
                    ((getEnumValueByEnumNameAndCode("AlertType", column.equipmentAlert?.alertType)?.[0]?.title) || ''),
                    ((getEnumValueByEnumNameAndCode("AlertCategory", column.equipmentAlert?.alertCategory)?.[0]?.title) || ''),
                    // ((getEnumValueByEnumNameAndCode("SubwayLine", column.equipment?.station?.workingPart?.subwayLine)?.[0]?.title) || ''),
                    // ((column.equipment?.station?.workingPart?.name) || ''),
                    // ((column.equipment?.station?.name) || ''),
                    ((column.equipment?.equipmentCtgr?.parent?.name) || ''),
                    ((column.equipment?.name) || ''),
                    ((column.equipment?.equipmentNo) || '')
                ];
                excelDatas.push(excelData);
              });
              // console.log(excelDatas)
              setExcelDatas(excelDatas);
            } else {
              setExcelDatas([]);
            }
          } else {
            setExcelDatas([]);
          }
        })
      } else {
        setExcelDatas([]);
      }
    })
  }
 
  const handleInput = (event) => {
    event.preventDefault();
    setSearchKeyword(event.target.value.trim());
  };

  const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    attentionObservationList(0);
    setExcelDatas([]);

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};
    if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
    if (observeStatus) {searchParamCopy.searchStatus = observeStatus};
    if (alertType) {searchParamCopy.searchType = alertType};
    // if (subwayCode) {searchParamCopy.searchSubway = subwayCode};
    // if (workingPartId) {searchParamCopy.searchWorkingPart = workingPartId};
    // if (stationId) {searchParamCopy.searchStation = stationId};
    if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
    if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
    if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
    setSearchParam(searchParamCopy)
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  const typeTapSearch = (vCode) => {
    //console.log(vCode);
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    //if (vCode && vCode !== 'sum') {
      setObserveStatus(vCode);
    //} else {
    //  setEquipmentFaultStatus('');
    //}
    initSearch();
    //attentionObservationList();
    
    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};

    searchParamCopy.searchKeyword = '';
    searchParamCopy.searchStatus = vCode;
    searchParamCopy.searchType = '';
    searchParamCopy.searchSubway = '';
    searchParamCopy.searchWorkingPart = '';
    searchParamCopy.searchStation = '';
    searchParamCopy.searchlevel1 = '';
    searchParamCopy.searchlevel2 = '';
    searchParamCopy.searchlevel3 = '';
    setSearchParam(searchParamCopy);
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  const initSearch = ()  => {
    //console.log('aaaa');
    //setObserveStatus('');
    setAlertType('');
    setSubwayCode('');
    setWorkingPartId('');
    setStationId('');
    setEquipmentCategoryLevel1Id('');
    setEquipmentCategoryLevel2Id('');
    setEquipmentCategoryLevel3Id('');
    //setSearchField('');
    // setToggleStr(!toggleStr);
    setCurrentPage(0);
    setSearchKeyword('');
    //searchKeywordRef.current.defaultValue = '';
    // setTimeout(() => {
    //   console.log('tabSearch');
    // }, 1000);
    setIsLoading(false);
    setExcelDatas([]);
  };

  return (
    <>
        <div className="mro_search">
          {/* <ul className='condition' style={{marginTop:"px"}}>
            <li className={`sum${falutStatusSelectColor}`} onClick={() => typeTapSearch('sum')} style={{cursor:"pointer"}}>전체: {totalGroupCount}</li>
            {groupCounts &&
              groupCounts.map(function(item, i) {
                falutStatusSelectColor = "";
                if (item.id === observeStatus) {
                  falutStatusSelectColor = " selected";
                }
                return (
                  <li key={i} className={`${item.id}${falutStatusSelectColor}`} onClick={() => typeTapSearch(item.id)} style={{cursor:"pointer"}}>{item.title}: {item.count}</li>      
                )
              }) }
          </ul> */}
          <Box component="form" >
            <div>
              <div>
                {getEnumValueByEnumName("AlertType") && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomEnumSelect
                    key={alertType}
                    label={t('message.common.subtitle.alertType')}
                    labelName={t('message.common.subtitle.alertType')}
                    name={'alertType'}
                    defaultValue={alertType}
                    onChange={(e)=>{
                      setAlertType(e.target.value);
                    }}
                    list={getEnumValueByEnumName("AlertType")}
                />
                </FormControl>
                }
                {/*{getEnumValueByEnumName("SubwayLine") && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomEnumSelect
                    key={subwayCode}
                    label={t('message.common.subtitle.subwayline')}
                    labelName={t('message.common.subtitle.subwayline')}
                    name={'subway'}
                    defaultValue={subwayCode}
                    onChange={(e)=>{
                      setSubwayCode(e.target.value);
                      setWorkingPartId('');
                      setStationId('');
                    }}
                    list={getEnumValueByEnumName("SubwayLine")}
                />
                </FormControl>
                }
                {workingParts && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomSelect
                    key={workingPartId}
                    label={t('message.common.subtitle.workingPart')}
                    labelName={t('message.common.subtitle.workingPart')}
                    name={'workPart'}
                    defaultValue={workingPartId}
                    onChange={(e)=>{
                      setWorkingPartId(e.target.value);
                      setStationId('');
                    }}
                    list={workingParts}
                />
                </FormControl>
                }
                {stations && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomSelect
                    key={stationId}
                    label={t('message.common.subtitle.station')}
                    labelName={t('message.common.subtitle.station')}
                    name={'station'}
                    defaultValue={stationId}
                    onChange={(e)=>{
                      setStationId(e.target.value);
                    }}
                    list={stations}
                />
                </FormControl>
                }*/}
                {equipmentCategoryLevel1s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomSelect
                    key={equipmentCategoryLevel1Id}
                    label={t('message.common.subtitle.equipment.level1')}
                    labelName={t('message.common.subtitle.equipment.level1')}
                    name={'level1'}
                    defaultValue={equipmentCategoryLevel1Id}
                    onChange={(e)=>{
                      setEquipmentCategoryLevel1Id(e.target.value);
                      setEquipmentCategoryLevel2Id('');
                      setEquipmentCategoryLevel3Id('');
                    }}
                    list={equipmentCategoryLevel1s}
                />
                </FormControl>
                }
                {equipmentCategoryLevel2s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomSelect
                    key={equipmentCategoryLevel2Id}
                    label={t('message.common.subtitle.equipment.level2')}
                    labelName={t('message.common.subtitle.equipment.level2')}
                    name={'level2'}
                    defaultValue={equipmentCategoryLevel2Id}
                    onChange={(e)=>{
                      setEquipmentCategoryLevel2Id(e.target.value);
                      setEquipmentCategoryLevel3Id('');
                    }}
                    list={equipmentCategoryLevel2s}
                />
                </FormControl>
                }
                {equipmentCategoryLevel3s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomSelect
                    key={equipmentCategoryLevel3Id}
                    label={t('message.common.subtitle.equipment.level3')}
                    labelName={t('message.common.subtitle.equipment.level3')}
                    name={'level3'}
                    defaultValue={equipmentCategoryLevel3Id}
                    onChange={(e)=>{
                      setEquipmentCategoryLevel3Id(e.target.value);
                    }}
                    list={equipmentCategoryLevel3s}
                />
                </FormControl>
                }
                <div style={{display:"inline-block"}}>
                {searchFields && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                  <CustomEnumSelect
                    key={searchField}
                    label={t('message.common.btn.search')}
                    labelName={t('message.common.btn.search')}
                    name={'searchField'}
                    defaultValue={searchField}
                    onChange={(e)=>{
                      setSearchField(e.target.value);
                    }}
                    list={searchFields}
                />
                </FormControl>
                }
                
                  <FormControl sx={{ m: 1 }} variant="standard">
                    <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                  </FormControl>

                  <Button variant="contained" style={{marginTop:"12px",padding:"6px 15px"}} onClick={handleSearch}><span className="material-symbols-outlined">search</span>{t('message.common.btn.search')}</Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
        
        <Box id="tableDiv">
          <DataGridPro
            rows={attentionObservations && attentionObservations !== undefined ? attentionObservations : []}
            columns={columns}
            onRowClick={(params, event)=>{navigate('/equipment-observe/'+params.row.id+searchParamString)}}// 상세정보 없을 경우 제외
            // onRowSelected={(e)=>{console.log(e)}}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />
        </Box>

        <div className="btn_right">
        {(excelDatas && excelDatas.length > 0) ?
          <div className='no-print-page'>
              <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${excelTitle}`} filename={`${fileName}.xlsx`} />
          </div>
          :
          (attentionObservations && attentionObservations.length > 0) ?
          <div className='no-print-page' style={{color:"#000"}}>
            <Box sx={{ display: 'flex', color:"#000" }}>
              {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
            </Box>
          </div>
          : ''
        }
        </div>

        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
    </>
  );
}
 
export default ObserveMaintenance;